// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1jlGj","errorLogs":"EditorFooter_errorLogs__VDlEu"};